(function () {
  var root = null;

  function closeAllDropdowns() {
    if (!root) return;
    root.querySelectorAll('[data-followswiss-dropdown]').forEach(function (dd) {
      var panel = dd.querySelector('[data-followswiss-dropdown-panel]');
      var toggle = dd.querySelector('[data-followswiss-dropdown-toggle]');
      if (panel) panel.classList.remove('is-open');
      dd.removeAttribute('data-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* Im Theme-Editor rendert Shopify diese Section bei jeder Einstellungs-
     änderung serverseitig neu und tauscht ihr HTML aus; ein zuvor
     ausgeführtes <script> läuft dabei nicht erneut. Elementreferenzen
     und ihre Listener werden deshalb in init(scope) gekapselt und bei
     jedem "shopify:section:load" auf das frische HTML neu gebunden. Die
     document-weiten Listener unten bleiben dauerhaft bestehen und lesen
     bei jedem Aufruf die aktuelle (von init zuletzt gesetzte) root-
     Referenz, statt bei jedem Reload dupliziert zu werden. */
  document.addEventListener('click', function (event) {
    if (!root) return;
    if (!root.contains(event.target)) {
      closeAllDropdowns();
      return;
    }
    var withinDropdown = event.target.closest('[data-followswiss-dropdown]');
    if (!withinDropdown) closeAllDropdowns();
  });

  document.addEventListener('pointerdown', function (event) {
    if (!root) return;
    var openDropdown = root.querySelector('[data-followswiss-dropdown][data-open]');
    if (!openDropdown || openDropdown.contains(event.target)) return;
    closeAllDropdowns();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllDropdowns();
  });

  function init(scope) {
    var newRoot = scope.querySelector('.followswiss-product');
    if (!newRoot) return;
    root = newRoot;

    var variantValueInput = root.querySelector('.followswiss-product__field > [data-followswiss-variant-value]');
    var garantieCheckbox = root.querySelector('[data-followswiss-garantie-checkbox]');
    var mainPriceEl = root.querySelector('[data-followswiss-price]');
    var priceBox = root.querySelector('[data-followswiss-price-box]');
    var moneyFormat = (priceBox && priceBox.getAttribute('data-money-format')) || '{{amount}}';

    var orderFields = root.querySelectorAll('[data-followswiss-order-field]');
    var confirmCheckbox = root.querySelector('[data-followswiss-confirm-checkbox]');
    var confirmError = root.querySelector('[data-followswiss-confirm-error]');
    var addCartBtn = root.querySelector('[data-followswiss-add-cart]');
    var buyNowBtn = root.querySelector('[data-followswiss-buy-now]');
    var statusEl = root.querySelector('[data-followswiss-order-status]');
    var upsellBlock = root.querySelector('[data-followswiss-upsell]');
    var upsellItems = root.querySelectorAll('[data-followswiss-upsell-toggle]');
    var rabattCompareEls = root.querySelectorAll('[data-followswiss-rabatt-price]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount.split('.')[0])
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    /* Fehlt zu einer Menge die passende Premium-Variante (Katalogpflegefehler),
       ist data-price-premium-cents leer -> parseInt('')||0 würde CHF 0.00
       anzeigen. Stattdessen auf den Basispreis zurückfallen, damit die Anzeige
       nie einen irreführenden Nullpreis zeigt (der eigentliche Checkout wird
       ohnehin separat durch die fehlende Varianten-ID blockiert). */
    function centsWithFallback(primary, fallback) {
      var parsedPrimary = parseInt(primary, 10);
      if (!isNaN(parsedPrimary)) return parsedPrimary;
      var parsedFallback = parseInt(fallback, 10);
      return isNaN(parsedFallback) ? 0 : parsedFallback;
    }

    function getMainPriceCents() {
      var selected = root.querySelector('.followswiss-product__field > .followswiss-product__dropdown .followswiss-product__dropdown-option.is-selected');
      if (!selected) return 0;
      if (selected.hasAttribute('data-variant-id-base')) {
        var isPremium = !!(garantieCheckbox && garantieCheckbox.checked);
        var baseCents = selected.getAttribute('data-price-base-cents');
        var cents = isPremium ? selected.getAttribute('data-price-premium-cents') : baseCents;
        return centsWithFallback(cents, baseCents);
      }
      return parseInt(selected.getAttribute('data-price-cents'), 10) || 0;
    }

    function getUpsellTotalCents() {
      var total = 0;
      upsellItems.forEach(function (checkbox) {
        if (!checkbox.checked) return;
        var wrapper = checkbox.closest('.followswiss-product__upsell-item');
        var selectedOption = wrapper ? wrapper.querySelector('.followswiss-product__dropdown-option.is-selected') : null;
        if (!selectedOption) return;
        if (selectedOption.hasAttribute('data-variant-id-base')) {
          var isPremium = !!(garantieCheckbox && garantieCheckbox.checked);
          var baseCents = selectedOption.getAttribute('data-price-base-cents');
          var cents = isPremium ? selectedOption.getAttribute('data-price-premium-cents') : baseCents;
          total += centsWithFallback(cents, baseCents);
        } else {
          total += parseInt(selectedOption.getAttribute('data-price-cents'), 10) || 0;
        }
      });
      return total;
    }

    function updateRabattCompare(totalCents) {
      rabattCompareEls.forEach(function (el) {
        var pct = parseInt(el.getAttribute('data-followswiss-rabatt-price'), 10) || 0;
        var discountedCents = Math.round(totalCents * (100 - pct) / 100);
        el.textContent = formatMoney(discountedCents);
      });
    }

    function updateTotalPriceDisplay() {
      if (!mainPriceEl) return;
      var totalCents = getMainPriceCents() + getUpsellTotalCents();
      mainPriceEl.textContent = formatMoney(totalCents);
      updateRabattCompare(totalCents);
    }

    root.querySelectorAll('[data-followswiss-dropdown]').forEach(function (dropdown) {
      var toggle = dropdown.querySelector('[data-followswiss-dropdown-toggle]');
      var panel = dropdown.querySelector('[data-followswiss-dropdown-panel]');
      var selectedText = dropdown.querySelector('[data-followswiss-dropdown-selected-text]');
      var options = dropdown.querySelectorAll('[data-followswiss-dropdown-option]');
      var valueInput = dropdown.parentElement.querySelector('[data-followswiss-variant-value]');

      if (!toggle || !panel) return;

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = panel.classList.contains('is-open');
        closeAllDropdowns();
        if (!isOpen) {
          panel.classList.add('is-open');
          dropdown.setAttribute('data-open', '');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          if (option.disabled) return;

          options.forEach(function (o) {
            o.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          if (option.hasAttribute('data-variant-id-base')) {
            var isPremium = !!(garantieCheckbox && garantieCheckbox.checked);
            var variantId = isPremium ? option.getAttribute('data-variant-id-premium') : option.getAttribute('data-variant-id-base');
            var price = isPremium ? option.getAttribute('data-price-premium') : option.getAttribute('data-price-base');
            var label = option.getAttribute('data-label') || option.textContent.trim();
            if (selectedText) selectedText.textContent = label + ' — ' + price;
            if (valueInput) valueInput.value = variantId;
          } else {
            if (selectedText) {
              selectedText.textContent = option.textContent.trim();
            }
            if (valueInput) {
              valueInput.value = option.getAttribute('data-variant-id');
            }
          }

          updateTotalPriceDisplay();
          closeAllDropdowns();
        });
      });
    });

    if (garantieCheckbox) {
      garantieCheckbox.addEventListener('change', function () {
        var isPremium = garantieCheckbox.checked;
        root.querySelectorAll('.followswiss-product__dropdown-option.is-selected[data-variant-id-base]').forEach(function (selectedOption) {
          var dropdown = selectedOption.closest('[data-followswiss-dropdown]');
          if (!dropdown) return;
          var valueInput = dropdown.parentElement.querySelector('[data-followswiss-variant-value]');
          var selectedTextEl = dropdown.querySelector('[data-followswiss-dropdown-selected-text]');
          var variantId = isPremium ? selectedOption.getAttribute('data-variant-id-premium') : selectedOption.getAttribute('data-variant-id-base');
          var price = isPremium ? selectedOption.getAttribute('data-price-premium') : selectedOption.getAttribute('data-price-base');
          var label = selectedOption.getAttribute('data-label') || selectedOption.textContent.trim();
          if (valueInput) valueInput.value = variantId;
          if (selectedTextEl) selectedTextEl.textContent = label + ' — ' + price;
        });
        updateTotalPriceDisplay();
      });
    }

    function updateUpsellVisibility() {
      if (!upsellBlock) return;
      upsellBlock.hidden = !(confirmCheckbox && confirmCheckbox.checked);
    }

    upsellItems.forEach(function (checkbox) {
      var wrapper = checkbox.closest('.followswiss-product__upsell-item');
      var controls = wrapper ? wrapper.querySelector('[data-followswiss-upsell-controls]') : null;

      checkbox.addEventListener('change', function () {
        if (controls) controls.hidden = !checkbox.checked;
        closeAllDropdowns();
        updateTotalPriceDisplay();
      });
    });

    function getSelectedUpsells() {
      var selected = [];
      upsellItems.forEach(function (checkbox) {
        if (!checkbox.checked) return;
        var wrapper = checkbox.closest('.followswiss-product__upsell-item');
        var valueInput = wrapper ? wrapper.querySelector('[data-followswiss-variant-value]') : null;
        if (valueInput && valueInput.value) {
          selected.push(parseInt(valueInput.value, 10));
        }
      });
      return selected;
    }

    function showStatus(message, isError) {
      if (!statusEl) return;
      statusEl.textContent = message;
      statusEl.hidden = false;
      statusEl.classList.toggle('is-error', !!isError);
      statusEl.classList.toggle('is-success', !isError);
    }

    function validate() {
      var valid = true;

      if (confirmError) confirmError.hidden = true;

      orderFields.forEach(function (field) {
        field.classList.remove('is-invalid');
        if (!field.value.trim()) {
          field.classList.add('is-invalid');
          valid = false;
        }
      });

      if (confirmCheckbox && !confirmCheckbox.checked) {
        if (confirmError) confirmError.hidden = false;
        valid = false;
      }

      return valid;
    }

    function updateConfirmCheckboxAvailability() {
      if (!confirmCheckbox) return;
      var allFilled = true;
      orderFields.forEach(function (field) {
        if (!field.value.trim()) allFilled = false;
      });
      confirmCheckbox.disabled = !allFilled;
      if (!allFilled && confirmCheckbox.checked) {
        confirmCheckbox.checked = false;
        updateUpsellVisibility();
        updateTotalPriceDisplay();
      }
    }

    orderFields.forEach(function (field) {
      /* Manche Autofill-Mechanismen (Passwort-Manager, Browser-Erweiterungen)
         setzen .value, ohne ein natives 'input'-Event auszulösen — dann bliebe
         die Bestätigungs-Checkbox fälschlich deaktiviert. 'change' und 'blur'
         decken diese Fälle zusätzlich ab. */
      field.addEventListener('input', function () {
        field.classList.remove('is-invalid');
        updateConfirmCheckboxAvailability();
      });
      field.addEventListener('change', updateConfirmCheckboxAvailability);
      field.addEventListener('blur', updateConfirmCheckboxAvailability);
    });

    if (confirmCheckbox) {
      confirmCheckbox.addEventListener('change', function () {
        if (confirmCheckbox.checked && confirmError) {
          confirmError.hidden = true;
        }
        updateUpsellVisibility();
        updateTotalPriceDisplay();
      });
    }

    updateConfirmCheckboxAvailability();
    updateUpsellVisibility();
    updateTotalPriceDisplay();

    function buildProperties() {
      var properties = {};
      orderFields.forEach(function (field) {
        properties[field.getAttribute('data-field-name')] = field.value.trim();
      });
      return properties;
    }

    function setButtonsDisabled(disabled) {
      if (addCartBtn) addCartBtn.disabled = disabled;
      if (buyNowBtn) buyNowBtn.disabled = disabled;
    }

    function addToCart(redirectToCheckout) {
      if (!validate()) {
        showStatus('Bitte fülle alle Pflichtfelder aus.', true);
        return;
      }

      if (!variantValueInput || !variantValueInput.value) {
        showStatus('Bitte wähle eine Option aus.', true);
        return;
      }

      setButtonsDisabled(true);
      if (statusEl) statusEl.hidden = true;

      var items = [
        {
          id: parseInt(variantValueInput.value, 10),
          quantity: 1,
          properties: buildProperties()
        }
      ];

      getSelectedUpsells().forEach(function (variantId) {
        items.push({ id: variantId, quantity: 1 });
      });

      /* Bleibt eine Verbindung stumm hängen (z. B. ein Proxy, der die
         Antwort verschluckt), löst fetch() ohne Zeitlimit nie auf — die
         Buttons blieben sonst dauerhaft deaktiviert, ohne Fehlermeldung. */
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeoutId = controller
        ? setTimeout(function () { controller.abort(); }, 15000)
        : null;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (timeoutId) clearTimeout(timeoutId);
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error((data && data.description) || 'Fehler beim Hinzufügen.');
            });
          }
          return response.json();
        })
        .then(function () {
          if (window.followswissUpdateCartBadge) {
            window.followswissUpdateCartBadge(items.length);
          }
          if (redirectToCheckout) {
            window.location.href = '/checkout';
            return;
          }
          setButtonsDisabled(false);
          showStatus('Zum Warenkorb hinzugefügt.', false);
        })
        .catch(function (error) {
          if (timeoutId) clearTimeout(timeoutId);
          setButtonsDisabled(false);
          var message = error && error.name === 'AbortError'
            ? 'Zeitüberschreitung — bitte versuche es erneut.'
            : (error.message || 'Es ist ein Fehler aufgetreten.');
          showStatus(message, true);
        });
    }

    if (addCartBtn) {
      addCartBtn.addEventListener('click', function () {
        addToCart(false);
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        addToCart(true);
      });
    }
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();